import {AlertService} from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AssessmentService } from "../../shared/services/assessment.service";
import { QuestionSet } from "../../shared/models/question-set";
import { Assessment } from "../../shared/models/assessment";

@Component({
  selector: 'app-question-set-new',
  templateUrl: './question-set-new.component.html',
  styleUrls: ['./question-set-new.component.css']
})
export class QuestionSetNewComponent implements OnInit {

  private _questionSet:QuestionSet;
	private assessment:Assessment;

  constructor(
     private _assessmentService:AssessmentService
    ,private route:ActivatedRoute
    ,private router:Router
    ,private alertService:AlertService
  ) { 
    this.questionSet = new QuestionSet();
    this.questionSet.title = "Untitled";
    this.questionSet.id = this._assessmentService.newId();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let setId = params['setId'];
      this._assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
        });
    });
  }

  get questionSet() : QuestionSet {
    return this._questionSet;
  }

  set questionSet(v:QuestionSet) { 
    this._questionSet = v;
  }

  save() {
    this.assessment.addQuestionSet(this._questionSet);
		this._assessmentService.saveAssessment(this.assessment).then((assessment) => {
      this.alertService.success("Question Set Saved!")
        setTimeout(() => {
          this.router.navigate(["../", this._questionSet.id, "edit"], {relativeTo: this.route, replaceUrl: true});
        },1500);
    }).catch((error) => {
      this.alertService.error("Error occurred in saving. Please try again");
      console.error(error);
    });
	}
}


// WEBPACK FOOTER //
// ./src/app/admin/question-set-new/question-set-new.component.ts